<template>
  <div class="policyServiceCon">
    <!-- 政策服务 -->
    <div class="banner">
      <img
        src="~@/assets/images/swzq_banner1.jpg"
        width="100%"
        height="200"
        alt=""
      />
      <!-- <div class="wrap-breadcrumb">
        <span style="font-size: 18px">当前位置：</span>
        <el-breadcrumb
          separator-class="el-icon-arrow-right"
          style="font-size: 18px; display: inline-block; margin-left: 8px"
        >
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: 'policyService' }"
            >税惠直达专区</el-breadcrumb-item
          >
        </el-breadcrumb>
      </div> -->
      <!-- <div class="bannerInfo"></div>
            <div class="bannerImg"></div> -->
    </div>
    <!-- <div class="listContainer">
            <div class="top">
                <div style="display: flex; align-items: center">
                    <span class="node"></span>
                    <span class="subTitie">政策服务</span>
                </div>
                <div style="display: flex; align-items: center">
                    <div class="input-search-bar">
                        <el-input
                            class="input-search"
                            style="font-size: 16px"
                            v-model.trim="inputKeyWord"
                            placeholder="请输入关键字"
                        >
                        </el-input>
                        <el-button
                            class="input-search-btn"
                            type="primary"
                        ><span style="font-size: 18px"> 搜索</span>
                        </el-button>
                    </div>
                    <el-button
                        type="primary"
                        class="resetBtn"
                    >重置</el-button>
                    <span @click="showFilter">条件筛选 <i class="el-icon-caret-bottom"></i></span>
                </div>
            </div>
            <div
                class="filter"
                v-show="filterVisible"
            ></div>
            <el-table
                :data="tableData"
                class="tableStyle"
                :show-header="false"
            >
                <el-table-column
                    label=""
                    width="1000"
                    show-overflow-tooltip
                    prop="title"
                >
                    <template slot-scope="scope">
                        <div class="column1">
                            <p style="font-size:18px"><i class="dot"></i>{{ scope.row.title }}</p>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    label=""
                    prop="time"
                > </el-table-column>
            </el-table>
            <el-pagination
                style="margin-top: 10px"
                background
                :page-size="5"
                layout="prev, pager, next,total, jumper"
                prev-text="上一页"
                next-text="下一页"
                :total="12"
                @size-change="handleSizeChange"
                @current-change="CurrentChange"
            >
            </el-pagination>
        </div> -->
    <!-- 惠税直达 -->
    <div class="nav flexStyle">
      <div class="wrap-container flexStyle">
        <ul class="tabbar" @click="changeTab">
          <li
            v-for="(item, index) in tabInfo.list"
            :key="index"
            class="tab-item flexStyle"
            :class="{ 'tab--active': tabInfo.active === item.value }"
            :data-cpn="item.value"
          >
            {{ item.label }}
          </li>
        </ul>
      </div>
    </div>
    <div class="def-container" style="margin-top: -104px">
      <!-- <keep-alive> -->
      <component
        :is="tabInfo.active"
        @backEvent="backEvent"
        ref="policyConsult"
      ></component>
      <!-- </keep-alive> -->
    </div>
    <!-- 右侧侧边导航 -->
    <div class="sideNav flexStyle2" v-show="tabInfo.active != 'PolicyConsult'">
      <div
        @click="toNewPage('onlineConsult')"
        class="flexStyle2"
        v-show="foldFlag"
      >
        <i class="el-icon-chat-line-round"></i>在线咨询
      </div>
      <div
        @click="toNewPage('phoneConsult')"
        class="flexStyle2"
        v-show="foldFlag"
      >
        <i class="el-icon-phone"></i>电话咨询
      </div>
      <div
        @click="toNewPage('handleConsult')"
        class="flexStyle2"
        v-show="foldFlag"
      >
        <i class="el-icon-s-claim"></i>在线办理
      </div>
      <div
        @click="toNewPage('orderConsult')"
        class="flexStyle2"
        v-show="foldFlag"
      >
        <i class="el-icon-user-solid"></i>预约专家团队咨询
      </div>
      <div
        @click="toNewPage('complaintConsult')"
        class="flexStyle2"
        v-show="foldFlag"
      >
        <i class="el-icon-phone-outline"></i>在线投诉
      </div>
      <div
        @click="toNewPage('onlineJudge')"
        class="flexStyle2"
        v-show="foldFlag"
      >
        <i class="el-icon-chat-line-round"></i>在线评价
      </div>
      <i class="fold" @click="fold"></i>
      <div v-show="!foldFlag" class="foldTxt flexStyle2">快捷功能</div>
    </div>
  </div>
</template>

<script>
import SfPolicyLibrary from "./sf-policy-library/SfPolicyLibrary";
import SwPolicySubscription from "./sw-policy-subscription/SwPolicySubscription";
import SwPolicyVip from "./sw-policy-vip/SwPolicyVip";
import AccurateMatch from "./accurate-match/AccurateMatch";
import PolicyConsult from "./policy-consult/PolicyConsult";
import SsPolicyGuide from "./ss-policy-guide/SsPolicyGuide";

const tableData = [];
export default {
  name: "policyService",
  components: {
    SfPolicyLibrary,
    SwPolicySubscription,
    SwPolicyVip,
    AccurateMatch,
    PolicyConsult,
    SsPolicyGuide,
  },
  props: {},
  data() {
    return {
      foldFlag: true,
      tableData,
      inputKeyWord: "",
      filterVisible: false,
      tabInfo: {
        active: "SfPolicyLibrary",
        list: [
          { value: "SfPolicyLibrary", label: "税费政策库" },
          // { value: "SwPolicySubscription", label: "税务政策订阅" },
          { value: "SwPolicyVip", label: "税费直达快享" },
          { value: "AccurateMatch", label: "政策模拟匹配" },
          { value: "SsPolicyGuide", label: "行业政策指引" },
          { value: "PolicyConsult", label: "在线咨询办理" },
        ],
      },
    };
  },
  created() {
    if (sessionStorage.getItem("tabInfo_active")) {
      this.tabInfo.active = sessionStorage.getItem("tabInfo_active");
    }
    this.$store.dispatch("dictionary/commonSetDic", {
      types: [
        "tax_ws", // 我是(哈哈?)
        // 'tax_wyz', // 我要找(哈哈?)
        "sq_policy_zjlx", // 扶持方式(支持方式)
      ],
    });
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    fold() {
      let navFix = document.querySelector(".sideNav");
      let arrow = document.querySelector(".fold");
      this.foldFlag = !this.foldFlag;
      if (this.foldFlag) {
        // navFix.style.background = "red";
        // navFix.style.borderColor = "red";
        navFix.style.background = "#1472FF";
        navFix.style.borderColor = "#1472FF";
        // arrow.classList.remove("rotate");
        arrow.style.right = "0%";
        arrow.style.top = "465px";
      } else {
        navFix.style.background = "transparent";
        navFix.style.borderColor = "transparent";
        // arrow.classList.add("rotate");
        arrow.style.right = "0%";
        arrow.style.top = "270px";

      }
    },
    handleScroll() {
      let navFix = document.querySelector(".sideNav");
      // let sy = window.pageYOffset || document.body.scrollTo || document.documentElement.scrollTop;
      navFix.style.position = "fixed";
      navFix.style.top = "200px";
      navFix.style.zIndex = 1000;
      // if (sy >= 288) {
      //   navFix.style.position = "fixed";
      //   navFix.style.top = "200px";
      //   navFix.style.zIndex = 1000;
      // } else {
      //   navFix.style.position = "fixed";
      //   navFix.style.top = "200px";
      // }
    },
    toNewPage(param) {
      switch (param) {
        case "orderConsult":
        case "handleConsult":
        case "phoneConsult":
          this.tabInfo.active = "PolicyConsult";
          sessionStorage.setItem("showFlag", param);
          break;
        case "onlineConsult":
          let href = "https://12366.chinatax.gov.cn/xiaohui/";
          window.open(href, "_blank");
          break;
        case "complaintConsult":
          let href2 =
            "https://henan.chinatax.gov.cn/xinyang/hdjl/sswfxwjj/wyxx/index.html";
          window.open(href2, "_blank");
          break;
        case "onlineJudge":
          let href3 = "https://www.wjx.cn/vj/tG73KG4.aspx";
          window.open(href3, "_blank");
          break;
        default:
          break;
      }
    },
    backEvent(parm) {
      this.tabInfo.active = parm;
    },
    /**
     * @description: 切换tab
     * @param {Event} e Event
     */
    changeTab(e) {
      // console.log('goQuickEntry:', e)
      if (e.target.nodeName.toLowerCase() === "li") {
        this.tabInfo.active = e.target.getAttribute("data-cpn");
        if (this.tabInfo.active == "PolicyConsult") {
          sessionStorage.setItem("showFlag", "");
        }
      }
      sessionStorage.setItem("activeMenu", this.tabInfo.active);
    },
    handleSizeChange() {},
    CurrentChange() {},
    showFilter() {
      this.filterVisible = !this.filterVisible;
    },
  },
};
</script>

<style lang='scss' scoped>
@import "@/styles/global.scss";
$width: 1150px;
.flexStyle {
  display: flex;
  justify-content: center;
  align-items: center;
}
.flexStyle2 {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  align-items: center;
}
.policyServiceCon {
  // margin-top: -20px;
  width: 100%;
  min-height: 1070px;
  // background: url("~@/assets/images/background.png") no-repeat;
  padding-bottom: 10px;
  background-size: 100% 1070px;
  position: relative;
  .sideNav {
    width: 100px;
    height: 460px;
    border: 1px solid #1472FF;
    color: #fff;
    background: #1472FF;
    position: absolute;
    right: 5px;
    // top: 288px;
    top: 60px;
    z-index: 1000;
    .fold {
      display: block;
      width:100%;
      height:50px;
      border: 1px solid #1472FF;
      background-color: #1472FF;
      background-image: url("~@/assets/images/fold1.png");
      background-position: center center;
      background-repeat: no-repeat;
      position: absolute;
      right: 0;
      top: 460px;
      font-size: 20px;
      cursor: pointer;
    }
    .foldTxt {
      width: 100px;
      height: 70px;
      margin-right:1px;
      font-size: 18px;
      border-radius: 3px;
      text-align: center;
      background-color: #1472FF;
      color:#fff;
    }
    .rotate {
      transform: rotate(180deg);
    }
    div {
      min-height: 50px;
      width: 70px;
      padding: 5px;
      border-radius: 3px;
      font-size: 14px;
      cursor: pointer;
      margin: 7px 0;
      &:hover {
        // color: #ffef69;
        background-color: #ff9000;
      }
      i {
        font-size: 30px;
        display: block;
      }
    }
  }
  .banner {
    width: 100%;
    height: 200px;
    margin: 0 auto;
    margin-bottom: -140px;
    position: relative;
    margin-bottom: 50px;

    .wrap-breadcrumb {
      width: $width;
      height: 52px;
      line-height: 52px;
      margin: 0 auto;
      color: #333;
      display: flex;
      align-items: center;
      position: absolute;
      top: 225px;
      left: 12%;
    }
    .bannerInfo {
      min-width: 664px;
      height: 105px;
      // background: url("~@/assets/images/policyServiceBanner.png")
      //     no-repeat;
    }
    .bannerImg {
      min-width: 423px;
      height: 254px;
      // background: url("~@/assets/images/bannerImg.png") no-repeat;
      background-size: contain;
    }
  }
  .listContainer {
    width: $width;
    margin: 0 auto;
    padding: 20px 40px 0 0;
    background: #fff;
    .top {
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;
      .node {
        display: inline-block;
        width: 5px;
        height: 35px;
        background-color: #1472FF;
      }
      .subTitie {
        margin-left: 10px;
        font-size: 20px;
        font-weight: 700;
        color: #1472FF;
      }
    }
    .input-search-bar {
      display: flex;
      // background-color: lightgreen;
      .input-search {
      }
      ::v-deep .el-input__inner {
        width: 280px;
        height: 40px;
        border-radius: 4px 0 0 4px !important;
      }
      ::v-deep .el-button--primary {
        height: 40px;
      }
    }
    .resetBtn {
      width: 80px;
      height: 40px;
      font-size: 18px;
      margin: 0 10px;
    }
    .filter {
      width: $width;
      min-height: 200px;
      background-color: #fff;
    }
    .tableStyle {
      width: 100%;
      margin-left: 20px;
      .column1 {
        display: flex;
        align-items: center;
        .dotCon {
          width: 26px;
        }
        .dot {
          display: inline-block;
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: #000;
          margin-right: 10px;
        }
      }
      .column1:hover .dot {
        background-color: #285ec9;
      }
    }
    ::v-deep .el-table .el-table__row:hover {
      color: #285ec9;
    }
    ::v-deep .el-pagination {
      padding-left: 720px;
    }
  }
}
::v-deep {
  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #1472FF;
  }
  .el-pagination.is-background .el-pager li:not(.disabled):hover {
    color: #333;
  }
}
.nav {
  width: 100%;
  min-height: 100px;
  background-image: url("~@/assets/images/swzq_nav1.png");
  background-position: center;
  position: relative;
  top: -105px;
}
.wrap-container {
  width: $width;
  margin: 0 auto;
}
.tabbar {
  position: relative;
  margin-top: 10px;
  font-size: 18px;
  padding-top: 20px;

  // &::after {
  //   content: "";
  //   position: absolute;
  //   bottom: 0;
  //   left: 0;
  //   width: 100%;
  //   height: 2px;
  //   background-color: #d71517;
  // }
}
.tab-item {
  display: inline-block;
  padding: 0.5rem 0;
  margin: auto 1.5rem;
  // font-weight: bold;
  // color: #d71517;
  color: #fff;
  cursor: pointer;

  &.tab--active {
    color: #ffef69;
    // background-color: #d71517;
    // border-bottom: 4px solid #ffef69;
  }
}
::v-deep {
  .el-breadcrumb__inner,
  .el-breadcrumb__separator {
    // color: #fff !important;
  }
}
</style>
